import { execPost } from '@/services/utils/RequestUtils';

interface IbanValidationResponse {
  readonly isIbanValid: boolean;
}

export function isValidIbanFormat(iban: string): boolean {
  const normalized = iban.replace(/\s+/g, '').toUpperCase();
  return normalized.length > 0 && /^[A-Z0-9]+$/.test(normalized);
}

export async function isValidIban(
  iban: string,
  accessToken: string,
): Promise<boolean> {
  const normalized = iban.replace(/\s+/g, '').toUpperCase();
  const response = await execPost<IbanValidationResponse>(
    'validation/iban',
    {
      iban: normalized,
    },
    accessToken,
  );
  return response.isIbanValid;
}
